// Tri-dot motif — signature element echoing the logo.
// Used in sidebar, login hero, bot avatars, active nav indicators.

interface Props {
  size?: number;
  gap?: number;
  animate?: boolean;
  tone?: 'mixed' | 'accent' | 'muted';
}

export const TriDot = ({ size = 6, gap = 4, animate = false, tone = 'mixed' }: Props) => {
  const colors =
    tone === 'mixed'
      ? ['#9CA3AF', '#6366F1', '#6366F1']
      : tone === 'accent'
        ? ['#6366F1', '#6366F1', '#6366F1']
        : ['#9CA3AF', '#9CA3AF', '#9CA3AF'];
  return (
    <span className="inline-flex items-center" style={{ gap }} aria-hidden>
      {colors.map((c, i) => (
        <span
          key={i}
          className={animate ? 'animate-tri-pulse' : ''}
          style={{
            width: size,
            height: size,
            borderRadius: '50%',
            background: c,
            display: 'block',
            animationDelay: animate ? `${i * 0.18}s` : undefined,
          }}
        />
      ))}
    </span>
  );
};
